import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=6e8055e0&scoped=true&"
import script from "./SwiperItem.vue?vue&type=script&lang=ts&"
export * from "./SwiperItem.vue?vue&type=script&lang=ts&"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=6e8055e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8055e0",
  null
  
)

export default component.exports